module.exports = __webpack_public_path__ + "customer_login.6d55fd81fc65e86868d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/Content/images/customer_login.png
// module id = 684
// module chunks = 1